// Room status options
export const STATUS_OPTIONS = ["Occupied", "Down", "Up"];

// Housekeeping requirement options
export const HOUSEKEEPING_OPTIONS = [
  "Refresh",
  "Easy",
  "Medium",
  "Heavy",
  "Very Heavy",
  "Completed",
  "Please select",
];

// Maintenance requirement options
export const MAINTENANCE_OPTIONS = [
  "Easy",
  "Medium",
  "Heavy",
  "Very Heavy",
  "Completed",
  "Please select",
];

// Vendor keys to check for vendor-needed rooms
export const VENDOR_KEYS = [
  "vendorElectricalRepair",
  "vendorPestControl",
  "vendorPlumbingRepair",
  "vendorTubResurface",
  "vendorWindow",
];

// Vendor list for manipulated items
export const VENDORS_LIST = [
  { itemID: "vendorElectricalRepair", itemName: "Electrical Repair" },
  { itemID: "vendorPestControl", itemName: "Pest Control" },
  { itemID: "vendorPlumbingRepair", itemName: "Plumbing Repair" },
  { itemID: "vendorTubResurface", itemName: "Tub Resurface" },
  { itemID: "vendorWindow", itemName: "Window" },
  { itemID: "vendorSubfloor", itemName: "Subfloor Repair" },
];

// Room filter types
export const ROOM_FILTER_TYPES = {
  ALL: "all rooms",
  AVAILABLE: "available rooms",
  DOWN: "down rooms",
  VENDOR_NEEDED: "vendor needed rooms",
  TURNABLE: "turnable rooms",
  OCCUPIED: "occupied rooms",
  VACANT: "vacant rooms",
};

// New item type for vendor needed category
export const VENDOR_NEEDED_ITEM_TYPE = "Vendor Needed";